/**
 * @generated SignedSource<<17e65c4e37f8f977a477d43cc32a8bb2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraTimeFormat = "DAYS" | "HOURS" | "PRETTY" | "%future added value";
export type JiraTimeUnit = "DAY" | "HOUR" | "MINUTE" | "WEEK" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type timeSpentField_updateWorkItemFieldsActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly timeSpent: {
    readonly timeInSeconds: AGG$Long | null;
  } | null;
  readonly timeTrackingSettings: {
    readonly defaultFormat: JiraTimeFormat | null;
    readonly defaultUnit: JiraTimeUnit | null;
    readonly isJiraConfiguredTimeTrackingEnabled: boolean | null;
    readonly workingDaysPerWeek: number | null;
    readonly workingHoursPerDay: number | null;
  } | null;
  readonly " $fragmentType": "timeSpentField_updateWorkItemFieldsActionRenderer";
};
export type timeSpentField_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: timeSpentField_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"timeSpentField_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "timeSpentField_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraTimeTrackingSettings",
      "kind": "LinkedField",
      "name": "timeTrackingSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isJiraConfiguredTimeTrackingEnabled"
        },
        {
          "kind": "ScalarField",
          "name": "workingHoursPerDay"
        },
        {
          "kind": "ScalarField",
          "name": "workingDaysPerWeek"
        },
        {
          "kind": "ScalarField",
          "name": "defaultFormat"
        },
        {
          "kind": "ScalarField",
          "name": "defaultUnit"
        }
      ]
    },
    {
      "concreteType": "JiraEstimate",
      "kind": "LinkedField",
      "name": "timeSpent",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "timeInSeconds"
        }
      ]
    }
  ],
  "type": "JiraTimeTrackingField"
};

(node as any).hash = "49f036b56e6dbebd7bd50865073bb864";

export default node;
